import classes from "./InvoiceData.module.scss";
import { useState, useEffect, useContext, useRef } from "react";
import InputText from "../../../../UI/Inputs/InputText/InputText";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import SystemContext from "../../../../../context/SystemContext";
import * as kApi from "../../../../../constants/api";
import { PROD } from "../../../../../constants/defaults";
import { useTranslation } from "react-i18next";
import InputAutocomplete from "../../../../UI/Inputs/InputAutocomplete/InputAutocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { isValidCPF, isValidCNPJ } from "../../../../../helpers/utilityHelpers";

const InvoiceData = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const payload = useSelector((state) => state.purchase);
  const isProd = kApi.GET_PROD_OR_DEV === PROD;
  const [address, setAddress] = useState(null);
  const isFetchingCep = useRef(false);
  const [isBrasil, setIsBrasil] = useState(true);
  const { CheckError, setCheckError,changePropertyUrl } = useContext(SystemContext);
  const [NotExistError, setNotExistError] = useState();
  const [Mask, setMask] = useState({
    document: "",
  });
  const { session } = useSelector((state) => state.session);
  const my_user = session?.my_user;
  const [options, setOptions] = useState(null);
  const [errorServer, setErrorServer] = useState({});
  const [stateErrorServer, setStateErrorServer] = useState(0);

  const [InvoiceInfo, setInvoiceInfo] = useState({
    country: "",
    zipcode: "",
    document: "",
    name: "",
    phone: "",
    street: "",
    number: "",
    complement: "",
    city: "",
    state: "",
    neighborhood: "",
    email: "",
  });

  const [errorRule, setErrorRule] = useState({
    country: null,
    zipcode: null,
    document: null,
    name: null,
    street: null,
    number: null,
    city: null,
    state: null,
    neighborhood: null,
  });
  const mapRuleString = {
    "registry_code": "document"
  }

  const fetchOptions = async () => {
    try {
      const response = await axios.get(kApi.API_URL_STATIC_OPTIONS);
      setOptions(response.data);
    } catch (error) {
      console.error("Erro ao buscar as opções: ", error);
    }
  };

  useEffect(() => {
      changePropertyUrl("",{etapa:"fatura"});
  }, []);

  useEffect(() => {
    if (options === null) {
      fetchOptions();
    }
  }, [options]);

  const fetchAddress = async (zipcode = "") => {
    if (isFetchingCep.current) return false;
    isFetchingCep.current = true;
    try {
      const response = await axios.get(
        `https://opencep.com/v1/${(zipcode || InvoiceInfo.zipcode).replace("-", "")}`
      );
      if ("erro" in response.data) {
        return true
      }
      setAddress(response.data);
      console.log("response data", response.data);
      return false
    } catch (error) {
      console.error("Erro ao buscar o endereço:", error);
      if (error.code === "ERR_NETWORK" || error.code === "ERR_CONNECTION_RESET") return false;
      return true
    } finally {
      isFetchingCep.current = false;
    };
  }
  /*   const handleKeyDown = (e) => {
      if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        fetchAddress();
      }
    }; */

  // useEffect(() => {
  //   console.log("payload", payload);
  //   if (payload && payload.purchase && payload.purchase.errorList) {
  //     setErrorRule((prevState) => ({
  //       ...prevState,

  //     }));
  //   }
  // });

  useEffect(() => {
    if (stateErrorServer === 1) {

      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
          errorList: payload.purchase.errorList || []
        },
        PostData: {
          invoice_info: {
            country: InvoiceInfo.country,
            zipcode: InvoiceInfo.zipcode,
            document: InvoiceInfo.document,
            name: InvoiceInfo.name.replace(/[^\p{L}\s]/gu, ""),
            phone: InvoiceInfo.phone,
            street: InvoiceInfo.street,
            number: InvoiceInfo.number,
            complement: InvoiceInfo.complement,
            city: InvoiceInfo.city,
            state: InvoiceInfo.state,
            neighborhood: InvoiceInfo.neighborhood,
            email: session?.email,
          },
        },
      });
    }
  }, [InvoiceInfo]);

  useEffect(() => {
    setCheckError((prevState) => ({
      ...prevState,
      invoiceData: false,
      invoiceShowError: false,
      creditCard: false,
      creditCardShowError: false,
    }));
  }, []);

  useEffect(() => {
    const _notExistError = Object.values(errorRule).every(
      (value) => value === false
    );
    setNotExistError(_notExistError);
    const invoiceData = {
      invoiceData: _notExistError,
    };
    invoiceData["invoiceShowError"] = !_notExistError;
    setCheckError((prevState) => ({
      ...prevState,
      ...invoiceData,
    }));
  }, [errorRule]);

  useEffect(() => {
    if (payload && payload.purchase && (payload.purchase.errorList && payload.purchase.errorList.length > 0)) {
      const errorServer = (
        payload.purchase.errorList ? payload.purchase.errorList : []
      ).reduce((errorObject, errorMenssage) => {
        const keyError = (typeof errorMenssage === "string") ? errorMenssage.split("/").pop() : errorMenssage.parameter;
        const keySearch = Object.keys(errorRule).filter((key) =>
          keyError.includes(key) || (mapRuleString.hasOwnProperty(keyError) && mapRuleString[keyError].includes(key))
        );
        if (keySearch.length > 0) {
          errorObject[keySearch[0]] = payload.purchase.invoice_state[keySearch[0]];
        }
        return errorObject;
      }, {});
      setErrorServer(errorServer);
    }
    /*     if (
          payload &&
          payload.purchase &&
          payload.purchase.tryClick &&
          !CheckError.invoiceData
        ) {
          setErrorRule(
            Object.keys(errorRule).reduce((finalRule, keyRule) => {
              return {
                ...finalRule,
                [keyRule]: mapRuleInput[keyRule](InvoiceInfo[keyRule]),
              };
            }, {})
          );
        } */
  }, [payload]);

  const mapRuleInput = {
    country: (value, deepCheck = false) => !value || value.length < 2,
    zipcode: async (value, deepCheck = false) => {
      if (!value) return true;
      if (!isBrasil) return value.length < 4;

      const cleanValue = value.replace(/\D/g, "");
      if (isBrasil) {
        let hasError = cleanValue.length < 8
        if (!hasError && deepCheck) {
          hasError = await fetchAddress(value);
        }
        return hasError;
      } else {
        return cleanValue.length < 6;
      }
    },
    document: (value, deepCheck = false) => {
      if (!value) return true;
      if (isBrasil && !isPortugal && value.length < 11) return true;
      if ((!isBrasil || isPortugal) && value.length < 5) return true;

      if (isBrasil && !isPortugal) {
        const cleanValue = value.replace(/\D/g, "");
        if (cleanValue.length === 11) {
          return !isValidCPF(cleanValue);
        } else if (cleanValue.length === 14) {
          return !isValidCNPJ(cleanValue);
        }
      }
      return false;
    },
    name: (value, deepCheck = false) => !value || value.length < 3,
    street: (value, deepCheck = false) => !value || value.length < 3,
    number: (value, deepCheck = false) => !value || value.length < 1,
    city: (value, deepCheck = false) => !value || value.length < 3,
    state: (value, deepCheck = false) => {
      if (!value) return !value;
      let hasError = false;
      if (isBrasil) {
        hasError =
          hasError ||
          !options.states.reduce(
            (notHaveState, state) =>
              notHaveState || state.toLowerCase() === value.toLowerCase(),
            false
          );
      }
      hasError = hasError || value.length < 2;
      return hasError;
    },
    neighborhood: (value, deepCheck = false) => !value || value.length < 1,
    complement: (value, deepCheck = false) => false,
  };

  const checkFilds = (field = "") => {
    // console.log("checkFilds", InvoiceInfo);
    // console.log("payload", payload);
    // setErrorRule((prevState) => ({
    //   ...prevState,
    //   ...errorServer,
    // }));
    // if (field && field == "zipcode") {
    //   check_errors_invoice("zipcode");
    // }
  };

  useEffect(() => {
    if (address) {
      const newAddress = {
        city: address.localidade,
        state: address.uf,
        //zipcode: address.cep,
        street: address.logradouro,
        neighborhood: address.bairro,
      }
      setInvoiceInfo((prevState) => ({
        ...prevState,
        ...newAddress
      }));
      const newErrorRule = {
        city: false,
        state: false,
      }
      newErrorRule.street = mapRuleInput.street(newAddress.street, true);
      newErrorRule.neighborhood = mapRuleInput.neighborhood(newAddress.neighborhood, true);
      setErrorRule((prevState) => ({
        ...prevState,
        ...newErrorRule,
      }));
      setFieldEdited("");
    }
  }, [address]);

  useEffect(() => {
    if (my_user && options && payload && stateErrorServer <= 0) {
      setStateErrorServer((stateErrorServer === 0) ? 1 : 2);
      const newInfo = {
        country: my_user?.address_country ?? "",
        zipcode: my_user?.address_zipcode ?? "", // preciso aplicar a mascara aqui
        document: my_user?.fiscal_document ?? "",
        name: my_user?.full_name ?? "",
        phone: "",
        street: my_user?.address_street ?? "",
        number: my_user?.address_number ?? "",
        complement: my_user?.address_complement ?? "",
        city: my_user?.address_city ?? "",
        state: my_user?.address_state ?? "",
        neighborhood: my_user?.address_neighborhood ?? "",
        email: session?.email ?? "",
      };

      if (payload.PostData && payload.PostData.invoice_info) {
        Object.keys(payload.PostData.invoice_info).forEach((key) => {
          if (
            payload.PostData.invoice_info[key] &&
            payload.PostData.invoice_info[key] !== ""
          ) {
            newInfo[key] = payload.PostData.invoice_info[key];
          }
        });
      }
      let newMaskDoocument = "";
      if (newInfo?.country === "Brasil") {
        setIsBrasil(true);
        //adicionar a máscara de CEP
        newInfo['zipcode'] = (newInfo['zipcode']) ? newInfo['zipcode'].replace(/(\d{5})(\d{3})/, "$1-$2") : "";
        newMaskDoocument = "000.000.000-000";
        if (newInfo['document'] && newInfo['document'].length === 11) {
          newInfo['document'] = newInfo['document'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

        } else if (newInfo['document'] && newInfo['document'].length === 14) {
          newInfo['document'] = newInfo['document'].replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }

        if (newInfo['document'] && newInfo['document'].length === 18) {
          newMaskDoocument = "00.000.000/0000-00";
        }

        //newInfo['document'] = (newInfo['document']) ? newInfo['document'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "";
      } else {
        setIsBrasil(newInfo?.country == "" ? true : false);
      }
      setMask((prevState) => ({
        ...prevState,
        document: newMaskDoocument,
      }));


      setInvoiceInfo((prevState) => ({
        ...prevState,
        ...newInfo,
      }));
      /*    const newRule = Object.keys(newInfo).reduce((finalRule, key) => {
           if (newInfo[key] !== "" && key in mapRuleInput) {
             const fieldError = key in errorServer && errorServer[key];
             finalRule[key] = fieldError || mapRuleInput[key](newInfo[key]);
           }
           return finalRule;
         }, {});
         setErrorRule((prevState) => ({
           ...prevState,
           ...newRule,
         })); */
    }
  }, [my_user, options, payload, errorServer]);

  useEffect(() => {
    //if (!InvoiceInfo || !InvoiceInfo.document) return;
    if (!isBrasil || isPortugal) {
      setMask((prevState) => ({
        ...prevState,
        document: "",
      }));
    } else if (InvoiceInfo?.document?.replace(/\D/g, "").length < 12) {
      if (["00.000.000/0000-00", ""].indexOf(Mask.document) > -1) {
        setMask((prevState) => ({
          ...prevState,
          document: "000.000.000-000",
        }));
      }
    } else {
      if (Mask.document === "000.000.000-000") {
        setMask((prevState) => ({
          ...prevState,
          document: "00.000.000/0000-00",
        }));
      }
    }
  }, [InvoiceInfo, isBrasil]);


  const check_errors_invoice = (field_extra_check = "") => {
    if (stateErrorServer === 0) return;
    //Campos a validar
    const fields = Object.keys(errorRule);
    // Verifica se todos os campos obrigatórios estão preenchidos
    /*     const FieldsFilled = fields.every(
          (key) => InvoiceInfo[key] && InvoiceInfo[key] !== ""
        ); */
    // if (FieldsFilled) {
    if (stateErrorServer === 2) {
      setStateErrorServer(1);
      return
    }

    const update_async_error = async () => {
      const newErrors = await fields.reduce(async (errorsRules, field) => {
        const finalErrorsRules = await errorsRules;
        let fieldError = true;
        if (InvoiceInfo[field] !== "" && field in mapRuleInput) {
          fieldError = field in errorServer && errorServer[field] && errorServer[field] == InvoiceInfo[field];
          if (!fieldError) {
            const checkField = await mapRuleInput[field](InvoiceInfo[field], field_extra_check == field);
            fieldError = checkField;
          }
        }
        if ((errorsRules[field] == null && InvoiceInfo[field] != "") || (errorsRules[field] != fieldError && field == field_extra_check))
          finalErrorsRules[field] = fieldError;
        return finalErrorsRules;
      }, Promise.resolve(errorRule));

      setErrorRule((prevState) => ({
        ...prevState,
        ...newErrors,
      }));
    };
    update_async_error();
    // }
  }
  const [fieldEdited, setFieldEdited] = useState(my_user && my_user.address_zipcode && my_user.address_zipcode != "" ? "zipcode" : "");
  useEffect(() => {
    check_errors_invoice(fieldEdited);
  }, [InvoiceInfo, errorServer]);

  const handleInputChange = async (e) => {
    // console.log("e", e);
    if (e === null) return 0;
    const { name, value, innerText } = e.target;
    let finalValue =
      innerText && innerText.length > 0 ? innerText : value ? value : "";
    // Permite apenas duas letras no campo "state" quando o país for Brasil
    if (name === "state" && InvoiceInfo.country === "Brasil") {
      finalValue = finalValue
        .slice(0, 2)
        .replace(/[^\p{L}]/gu, "")
        .toUpperCase();
    }
    if (InvoiceInfo[name] === finalValue) return 0;

    setFieldEdited(name);
    setInvoiceInfo((prevState) => ({
      ...prevState,
      [name]:
        name === "name" || name === "state" || name === "country"
          ? finalValue.replace(/[^\p{L}\s]/gu, "")
          : finalValue.replace(/[^a-zA-Z0-9\s]/g, ""),
    }));
    if (
      name === "country"
    ) {
      setIsBrasil(finalValue === "Brasil");
    }


  };

  function pixel() {
    const dataobj = JSON.stringify({
      data: [
        {
          event_name: "AddToCart",
          event_time: Math.floor(+new Date() / 1000),
          action_source: "website",
          event_source_url: window.location.href,
          user_data: {
            em: [
              "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068",
            ],
            ph: [null],
            client_user_agent: null,
            client_ip_address: null,
          },
          custom_data: {
            currency: "USD",
            value: 39.9,
          },
        },
      ],
    });
    if (isProd) {
      fetch(kApi.API_PIXEL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: dataobj,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          console.log(JSON.stringify(data));
        });
    }
  }

  useEffect(() => {
    pixel();
  }, []);

  useEffect(() => {
    if (CheckError.invoiceShowError) {
      const getErrorKey = Object.keys(errorRule).find(
        (key) => errorRule[key] === true
      );
      if (getErrorKey) {
        document
          .getElementById(getErrorKey)
          ?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [CheckError]);

  // Função para saber se devemos mostrar conteúdo adaptado para Portugal
  const isPortugal = InvoiceInfo.country === "Portugal";

  //Funções das labels quando for Portugal
  const zipCodeLabel = isPortugal
    ? t("purchase.postal_code_portugal")
    : t("purchase.postal_code");

  const documentLabel = isPortugal
    ? t("purchase.nif")
    : t("purchase.cpf_or_cnpj");

  const stateLabel = isPortugal
    ? t("purchase.province")
    : t("purchase.state_acronym");

  //Funções das mensagens de erros quando for Portugal
  const zipCodErrorText = isPortugal
    ? t("purchase.enter-the-postal-code")
    : t("purchase.enter_zip_code");

  const documentErrorText = isPortugal
    ? t("purchase.enter-the-nif")
    : t("purchase.enter_your_cpf_or_cnpj");

  const stateErrorText = isPortugal
    ? t("purchase.inform-the-province")
    : t("purchase.report_the_status");

  return (stateErrorServer === 1) ? (
    <div className={classes.InvoiceData}>
      {options && InvoiceInfo && (
        <InputAutocomplete
          label={t("purchase.country")}
          name="country"
          error={CheckError.invoiceShowError && errorRule.country}
          errorText={t("purchase.enter_the_country")}
          defaultValue={options?.countries.find(
            (country) =>
              country.name == InvoiceInfo?.country
          )}
          onChange={handleInputChange}
          onBlur={checkFilds}
          options={options ? options.countries : []}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return (
              <Box
                key={key}
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...optionProps}
              >
                <img
                  loading="lazy"
                  style={{ width: 24, height: 16, marginRight: 8 }}
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  alt=""
                />
                {option.name}
              </Box>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{
                ...params.inputProps,
                'data-testid': 'invoice_country_input',
              }}
              name="country"
              placeholder={t("purchase.country")}
              error={CheckError.invoiceShowError && errorRule.country}
            />
          )}
        />
      )}
      <InputText
        label={zipCodeLabel}
        placeholder={zipCodeLabel}
        name="zipcode"
        error={CheckError.invoiceShowError && errorRule.zipcode}
        errorText={zipCodErrorText}
        value={InvoiceInfo.zipcode}
        onChange={handleInputChange}
        onBlur={() => { checkFilds("zipcode") }}
        mask="00000-000"
        data-testid='invoice_zipCode_input'
      />
      <InputText
        classPrimary={classes.Input}
        label={t("purchase.full_name")}
        placeholder={t("purchase.full_name")}
        name="name"
        error={CheckError.invoiceShowError && errorRule.name}
        errorText={t("purchase.enter_full_name")}
        value={InvoiceInfo.name}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_fullName_input'
      />
      <InputText
        label={documentLabel}
        placeholder={documentLabel}
        name="document"
        error={CheckError.invoiceShowError && errorRule.document}
        errorText={documentErrorText}
        value={InvoiceInfo.document}
        onChange={handleInputChange}
        onBlur={checkFilds}
        mask={Mask.document}
        data-testid='invoice_document_input'
      />
      {isBrasil ? (
        <InputText
          label={stateLabel}
          placeholder={stateLabel}
          name="state"
          error={CheckError.invoiceShowError && errorRule.state}
          errorText={stateErrorText}
          value={InvoiceInfo.state}
          onChange={handleInputChange}
          onBlur={checkFilds}
          data-testid='invoice_state_input'
        />
      ) : (
        <InputText
          label={stateLabel}
          placeholder={stateLabel}
          name="state"
          error={CheckError.invoiceShowError && errorRule.state}
          errorText={stateErrorText}
          value={InvoiceInfo.state}
          onChange={handleInputChange}
          onBlur={checkFilds}
          data-testid='invoice_state_input'
        />
      )}

      <InputText
        label={t("purchase.city")}
        placeholder={t("purchase.city")}
        name="city"
        error={CheckError.invoiceShowError && errorRule.city}
        errorText={t("purchase.inform_the_city")}
        value={InvoiceInfo.city}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_city_input'
      />
      <InputText
        label={t("purchase.road")}
        placeholder={t("purchase.road")}
        name="street"
        error={CheckError.invoiceShowError && errorRule.street}
        errorText={t("purchase.inform_the_street")}
        value={InvoiceInfo.street}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_street_input'
      />
      <InputText
        label={t("purchase.neighborhood")}
        placeholder={t("purchase.neighborhood")}
        name="neighborhood"
        error={CheckError.invoiceShowError && errorRule.neighborhood}
        errorText={t("purchase.inform_the_neighborhood")}
        value={InvoiceInfo.neighborhood}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_neighborhood_input'
      />
      <InputText
        label={t("purchase.number")}
        placeholder={t("purchase.number")}
        name="number"
        error={CheckError.invoiceShowError && errorRule.number}
        errorText={t("purchase.enter_the_number")}
        value={InvoiceInfo.number}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_number_input'
      />
      <InputText
        label={t("purchase.complement")}
        placeholder={t("purchase.complement")}
        name="complement"
        value={InvoiceInfo.complement}
        onChange={handleInputChange}
        onBlur={checkFilds}
        data-testid='invoice_complement_input'
      />
    </div>
  ) : (<> </>);
};

export default InvoiceData;
